import axios from "axios";
import { getApiBaseUrl } from "../tools/ConfigurationReader.ts";
import { lsLoad } from "../tools/Storage.ts";
import StorageEnum from "../enums/Storage.enum.ts";
import { normalizeApiError } from "./normalize-api-errors.ts";

export const apiAxios = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: false,
});

apiAxios.interceptors.request.use((config) => {
  const token = lsLoad(StorageEnum.Jwt);

  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(normalizeApiError(error));
  },
);
